import { shuttoConfig, languageChangeText } from "./shuttoConfig";

export function switchingButton(switchingButtonEl) {
  $(switchingButtonEl)
    .children()
    .on("click", function () {
      $(this).siblings("button").removeClass("active");
      $(this).addClass("active");
      shuttoConfig();
      languageChangeText();
    });
}